<template>
  <div class="inner-dashboard">
    <loading
      v-model:active="campaignLoading"
      :is-full-page="true"
      loader="dots"
      :opacity="1"
    />
    <PropertyDashboardSidebarNav
      v-if="!campaignLoading"
      :propertyId="propertyId"
      :campaignId="campaignId"
      :showLeadIntro="showLeadIntro"
      :showTopIntro="showTopIntro"
    />
    <div class="container h-100 pt-4" v-if="!campaignLoading">
      <div
        class="property-dashboard-content-heading row justify-content-between"
      >
        <div class="heading-text col-12 col-md-6 mb-0">
          <div class="current-property">
            <button
              class="navbar-toggler ms-auto d-inline d-lg-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasMenu"
              aria-controls="offcanvasMenu"
            >
              <font-awesome-icon icon="compass" />
            </button>
            {{ campaignName }}
          </div>
          <div class="current-route">Top Tenant Contacts</div>
        </div>
      </div>
      <div class="position-relative section-data-conatiner">
        <loading
          v-model:active="isLoading"
          :is-full-page="false"
          loader="dots"
          :opacity="1"
        />
        <div
          class="section companies-container"
          v-for="(item, key) in companies"
          :key="key"
        >
          <div class="d-flex justify-content-start align-items-center">
            <img
              :src="item.logo"
              class="company-logo"
              v-if="isUrl(item.logo)"
            />
            <img
              src="@/assets/linkedin-company.svg"
              class="company-logo"
              v-else
            />
            <label class="form-label company-name">{{ item.name }}</label>
            <span>
              {{
                item.impressions
                  ? item.impressions.toLocaleString(undefined, {
                      maximumFractionDigits: 1,
                    })
                  : "N/A"
              }}
              views
            </span>
          </div>
          <div class="section-data-conatiner">
            <div class="companies-table">
              <DatatableComponent
                v-if="!isLoading"
                :data="item.contacts"
                :columns="columns"
                :options="{
                  paging: false,
                  searching: false,
                  info: false,
                  responsive: true,
                  stripeClasss: [],
                  ordering: true,
                  order: [[3, 'desc']],
                  fixedHeader: true,
                  scrollY:
                    item.contacts.length > 0
                      ? item.contacts.length * 55 > 400
                        ? 400
                        : item.contacts.length * 55
                      : 80,
                }"
                :keys="keys"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
@use 'datatables.net-bs5' as *

.section-data-conatiner
  min-height: 80px
.companies-table
  min-height: 30vh
  overflow-y: auto
.datatable
  width: 97%
  thead
    th
      white-space: nowrap
    tbody
      td
        white-space: nowrap
.top-section-container
  margin-bottom: 20px
  height: 210px
.form-label
  margin-bottom: 0 !important
.top10-section-container
  height: 340px
.top-section-container:last-child
  margin-bottom: 0
.company-logo
  height: 55px
  width: 55px
  margin: 0 24px 0 0
  border-radius: 50%
.company-name
  margin-right: 10px
</style>

<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import PropertyDashboardSidebarNav from "@/components/PropertyDashboardSidebarNav.vue";
import DatatableComponent from "@/components/DatatableComponent.vue";
import mockData from "@/utils/mockData.json";
import microsoft_logo from "../assets/microsoft_logo.jpeg";
import exxonmobil_logo from "../assets/exxonmobil_logo.jpeg";
import toyota_logo from "../assets/toyota_logo.jpeg";
import adobe_logo from "../assets/adobe_logo.jpeg";
import procter_and_gamble_logo from "../assets/procter_and_gamble_logo.jpeg";
import pepsico_logo from "../assets/pepsico_logo.jpeg";
import tesla_motors_logo from "../assets/tesla_motors_logo.jpeg";
import mastercard_logo from "../assets/mastercard_logo.jpeg";
import jpmorgan_logo from "../assets/jpmorgan_logo.jpeg";
import abbvie_logo from "../assets/abbvie_logo.jpeg";

export default {
  name: "TenantContactsView",
  setup(props) {
    return {
      campaignName: ref(null),
      isLoading: ref(true),
      companies: ref([]),
      columns: [
        {
          data: "First Name",
          defaultContent: "",
          className: "align-middle",
          render: function (data, type, row, meta) {
            if (type === "display") {
              return data + " " + row["Last Name"];
            }
          },
        },
        {
          data: "Title",
          defaultContent: "",
          className: "align-middle",
        },
        {
          data: "Company",
          defaultContent: "",
          className: "align-middle",
        },
        {
          data: "Email",
          defaultContent: "",
          className: "align-middle",
        },
        // {
        //   data: "Corporate Phone",
        //   defaultContent: "",
        //   className: "align-middle",
        //   render: function (data, type, row, meta) {
        //     var phone = data.replace("'", "");
        //     return phone;
        //   },
        // },
        {
          data: "Person Linkedin Url",
          className: "text-center align-middle",
          orderable: false,
          render: function (data, type, row, meta) {
            var url = new URL(`../assets/linkedin.png`, import.meta.url).href;
            return (
              '<a href="' +
              data +
              '" target="_blank" style="background-color:rgba(10, 102, 194, 0.1); padding: 9px; border-radius: 8px; display: inline-block;"><span class="d-flex align-items-center"> <img src="' +
              url +
              '" style="height:20px; width:20px;" /><span style="display:inline-block"></span></span></a>'
            );
          },
        },
      ],
      keys: ["Name", "Job Title", "Company", "Email", "LinkedIn"],
      showLeadIntro: ref(null),
      showTopIntro: ref(null),
      campaignLoading: ref(true),
    };
  },
  props: {
    propertyId: {
      type: String,
      required: true,
    },
    campaignId: {
      type: String,
      required: true,
    },
  },
  components: {
    PropertyDashboardSidebarNav,
    DatatableComponent,
  },
  computed: {},
  methods: {
    isUrl(str) {
      const urlPattern =
        /^(https?:\/\/[\w.-]+(:\d+)?(\/[\w./-]*)?(\?[\w=&%.-]*)?|\/[\w./-]+)$/;
      return urlPattern.test(str);
    },
    getCampaignInfo() {
      this.campaignLoading = true;
      var info = {
        campaignId: this.campaignId,
      };
      var _this = this;
      api()
        .getCampaignName(info)
        .then((res) => {
          if (res.data) {
            _this.campaignName = res.data.campaignName;
            var monthlyBudget = res.data.monthlyBudget;
            var showLeadContacts = res.data.showLeadContacts;
            var showTopContacts = res.data.showTopContacts;
            _this.showLeadIntro =
              !showLeadContacts && monthlyBudget && monthlyBudget < 1000;
            _this.showTopIntro =
              !showTopContacts && monthlyBudget && monthlyBudget < 1000;
          }
          _this.campaignLoading = false;
        });
    },
    getTop10CompaniesReport() {
      this.isLoading = true;
      var _this = this;
      if (
        this.campaignId == "652d4ce096d5ae0503069180" ||
        this.campaignId == "685c4bdcb856f40bca877fdf"
      ) {
        var mockCompanies = mockData.topTenantContacts;
        mockCompanies.forEach((mockCompany) => {
          if (mockCompany.logo) {
            switch (mockCompany.logo) {
              case "microsoft_logo":
                mockCompany.logo = microsoft_logo;
                break;
              case "exxonmobil_logo":
                mockCompany.logo = exxonmobil_logo;
                break;
              case "toyota_logo":
                mockCompany.logo = toyota_logo;
                break;
              case "tesla_motors_logo":
                mockCompany.logo = tesla_motors_logo;
                break;
              case "adobe_logo":
                mockCompany.logo = adobe_logo;
                break;
              case "procter_and_gamble_logo":
                mockCompany.logo = procter_and_gamble_logo;
                break;
              case "pepsico_logo":
                mockCompany.logo = pepsico_logo;
                break;
                break;
              case "mastercard_logo":
                mockCompany.logo = mastercard_logo;
                break;
              case "jpmorgan_logo":
                mockCompany.logo = jpmorgan_logo;
                break;
              case "abbvie_logo":
                mockCompany.logo = abbvie_logo;
                break;
            }
          }
        });
        _this.companies = mockCompanies;
        setTimeout(() => {
          _this.isLoading = false;
        }, 500);
      } else {
        var info = {
          campaignId: this.campaignId,
          top10withData: true,
          readReport: true,
        };
        api()
          .getTenantCompaniesData(info)
          .then((res) => {
            if (res.data) {
              _this.companies = res.data;
              _this.isLoading = false;
            }
          });
      }
    },
  },
  mounted() {
    this.getCampaignInfo();
    this.getTop10CompaniesReport();
  },
};
</script>